import { MailPreviousValidationDTO } from 'src/app/shared/interfaces';

export class MailValidationFiles {
  mailId: number;
  objet: string;
  serviceId: number;
  serviceLabel: string;
  documentName: string;
  dateUpload: string;
  name: string;
  extension: string;
  id: number;
  version: number;
  addNewVersion: boolean;
  createdByUserId: number;

  // added by frontend
  previousStep?: MailPreviousValidationDTO[];
  doesAPreviousStepExists?: boolean;
  contacts?: {
    label: string;
    value: number;
    userId: number;
  }[];
}
